import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function logError(error: Error | unknown, context?: Record<string, any>) {
  console.error('Error:', error);
  if (context) {
    console.error('Context:', context);
  }
  
  // In production, you might want to send this to a logging service
  if (process.env.NODE_ENV === 'production') {
    // Send to logging service
  }
}
